import { createContext, useCallback, useContext, useEffect, useState } from "react";

// Two supported languages: 'sr' (Serbian ijekavica, default), 'de' (German)
const dict = {
  sr: {
    "brand.tagline": "Kalkulator boravka",
    "brand.title": "Schengen 90 / 180",
    "brand.rule": "max 90 dana · 180-dnevni pomični period",
    "brand.forCompany": "za",

    "login.title": "Prijava",
    "login.subtitle": "Unesite naziv firme, korisničko ime i lozinku.",
    "login.company": "Firma",
    "login.companyPlaceholder": "Korisničko ime firme (npr. expresstrans)",
    "login.username": "Korisničko ime",
    "login.password": "Lozinka",
    "login.submit": "Prijavi se",
    "login.submitting": "Prijava...",
    "login.noSelfSignup": "Naloge kreira administrator.",
    "login.developedBy": "Razvijeno od strane",
    "login.errorEmpty": "Unesite korisničko ime i lozinku",
    "login.errorFailed": "Neuspješna prijava",
    "login.success": "Uspješna prijava",

    "header.loggedInAs": "Prijavljen kao",
    "header.admin": "Admin",
    "header.logout": "Odjava",

    "tabs.today": "Provjera za danas",
    "tabs.plan": "Planiranje putovanja",

    "chip.yearForQuickEntry": "Godina za brzi unos",
    "chip.viewing": "Prikazuje se",

    "status.ok": "Dozvoljeno",
    "status.warning": "Rizično - blizu limita",
    "status.overage": "Prekoračenje",
    "status.label": "Status:",
    "status.lastExit": "Posljednji dozvoljeni izlazak:",

    "metric.used": "Iskorišćeno dana",
    "metric.remaining": "Preostalo dana",
    "metric.mustExitBy": "Izlazak do:",
    "metric.mustExitBy.explainTitle": "Kako se dolazi do ovog datuma?",
    "metric.mustExitBy.explain": "Algoritam za svaki dan između danas i +180 dana simulira izlazak i računa koliko dana boravka bi bilo u pomjerljivom prozoru [D − 179, D]. Datum {date} je najkasniji gdje je taj zbir ≤ 90.",
    "metric.mustExitBy.note": "Kako se prozor pomjera naprijed, stariji boravci postepeno „ispadaju\" i oslobađaju mjesto novim danima.",
    "metric.overage": "Prekoračenje",
    "metric.window": "Aktivni period",
    "metric.windowSub": "180 kalendarskih dana",
    "metric.overageStart": "Prekoračenje od",
    "metric.reentry": "Ponovni ulazak od",

    "timeline.title": "Vremenska linija · 180 dana",
    "timeline.usageOf90": "Iskorišćenost limita od 90 dana",
    "timeline.legend.stay": "Dani boravka",
    "timeline.legend.active": "Aktivni (otvoren) boravak",
    "timeline.legend.overage": "Prekoračenje",
    "timeline.legend.free": "Slobodni dani",
    "timeline.days": "dana",
    "timeline.open": "otvoreno",
    "timeline.tooltip.noStay": "Nema boravka u ovom segmentu",
    "timeline.tooltip.overageHere": "Prekoračenje na ovim danima",

    "calendar.title": "Kalendarski prikaz",
    "calendar.today": "Danas",
    "calendar.legend.stay": "Dan boravka",
    "calendar.legend.overage": "Prekoračenje",
    "calendar.legend.window": "Aktivni 180-dnevni period",

    "add.title": "Dodaj putovanje",
    "add.subtitle": "Ulazak & Izlazak",
    "add.entry": "Ulazak",
    "add.exit": "Izlazak",
    "add.openTrip": "Otvoren boravak (izlazak još nije ostvaren)",
    "add.button": "Dodaj putovanje",
    "add.needEntry": "Unesite datum ulaska",
    "add.needExit": "Unesite datum izlaska ili označite otvoreni boravak",
    "add.exitBeforeEntry": "Datum izlaska ne može biti prije datuma ulaska",
    "add.saved": "Putovanje dodato",

    "trips.title": "Evidencija boravaka",
    "trips.count.one": "unos",
    "trips.count.many": "unosa",
    "trips.loading": "Učitavanje...",
    "trips.empty.title": "Još nema unijetih putovanja",
    "trips.empty.sub": "Dodajte prvo putovanje ili učitajte primjer.",
    "trips.totalPrefix": "Ukupno:",
    "trips.days.one": "dan",
    "trips.days.many": "dana",
    "trips.inWindow": "U aktuelnom prozoru:",
    "trips.overlap": "Preklapanje",
    "trips.ongoing": "u toku",
    "trips.open": "otvoren",
    "trips.showMore": "Prikaži još {n}",
    "trips.showLess": "Prikaži manje",
    "trips.legend.inWindow": "Ulazi u trenutni 180-dnevni prozor (računa se)",
    "trips.legend.outOfWindow": "Van prozora (više se ne računa)",
    "trips.closeTrip": "Zatvori boravak (danas)",
    "trips.closedOk": "Boravak zatvoren na {d}",

    "plan.checkTitle": "Provjera za budući datum",
    "plan.checkSubtitle": "Odaberi datum u budućnosti kao datum provjere.",
    "plan.checkDate": "Datum provjere",
    "plan.stat.used": "Iskorišćeno",
    "plan.stat.remaining": "Preostalo",
    "plan.stat.overage": "Prekoračenje",
    "plan.title": "Planiranje putovanja",
    "plan.subtitle": "Simuliraj planirani ulazak i izlazak da provjeriš da li je putovanje dozvoljeno.",
    "plan.plannedEntry": "Planirani ulazak",
    "plan.plannedExit": "Planirani izlazak",
    "plan.maxStayPrefix": "Maksimalan neprekidan boravak od",
    "plan.result.ok": "Putovanje je moguće",
    "plan.result.okSub": "Nakon planiranog boravka: {used}/90 dana, preostalo {remaining}.",
    "plan.result.exitBeforeEntry": "Izlazak je prije ulaska",
    "plan.result.exitBeforeEntrySub": "Provjerite unesene datume.",
    "plan.result.overage": "Prekoračenje za {days} {dayWord}",
    "plan.result.overageSub":
      "Predloženi boravak traje {plannedDays} dana - previše u odnosu na trenutno raspoloživo.",

    "actions.loadSample": "Učitaj primjer",
    "actions.exportPdf": "Izvoz PDF",
    "actions.importCsv": "Uvoz CSV",
    "actions.downloadCsvSample": "Preuzmi primjer CSV",
    "actions.reset": "Resetuj sve",
    "actions.resetConfirmTitle": "Obrisati sve unose?",
    "actions.resetConfirmSub":
      "Ova akcija briše cijelu evidenciju boravaka i ne može se poništiti.",
    "actions.cancel": "Odustani",
    "actions.confirmDelete": "Obriši sve",
    "actions.pdfOk": "PDF izvještaj generisan",
    "actions.pdfErr": "Greška pri generisanju PDF-a",
    "actions.csvOk": "Učitano {n} putovanja iz CSV-a",
    "actions.csvSkipped": " (preskočeno {n} nevažećih redova)",
    "actions.csvErr": "Neuspješan uvoz: {msg}",
    "actions.csvSample": "Primjer CSV-a preuzet",
    "actions.resetDone": "Svi unosi su obrisani",

    "explanation.title": "Kako radi pravilo 90 / 180?",
    "explanation.p1":
      "Državljani BiH, Srbije i Crne Gore mogu bez vize da borave u šengenskom prostoru najviše {b1}90 dana{b2} unutar bilo kog pomičnog perioda od {b1}180 dana{b2}.",
    "explanation.li1": "Za svaki datum provjere gleda se unazad tačno 180 kalendarskih dana.",
    "explanation.li2":
      "I {b1}dan ulaska{b2} i {b1}dan izlaska{b2} se računaju kao puni dani boravka.",
    "explanation.li3":
      "Boravci u različitim šengenskim državama se sabiraju kao jedinstven boravak.",
    "explanation.li4":
      "Novi dani se „oslobađaju\" postepeno - onog dana kada stari dan ispadne iz 180-dnevnog prozora.",
    "explanation.li5":
      "Ako su unosi preklopljeni, aplikacija ih spaja kako se dani ne bi računali dva puta.",
    "explanation.note":
      "Napomena: ovo je tehnički obračun. Nadležni granični organi zadržavaju pravo konačne odluke.",

    "disclaimer.title": "Napomena",
    "disclaimer.text":
      "Ova aplikacija služi kao informativni alat za tehnički obračun pravila 90/180 u šengenskom prostoru i ne predstavlja pravni savjet niti zvaničnu odluku nadležnih organa.",

    "admin.title": "Administracija",
    "admin.back": "Nazad",
    "admin.newAccount": "Novi nalog",
    "admin.users": "Korisnici",
    "admin.accounts.one": "nalog",
    "admin.accounts.many": "naloga",
    "admin.loading": "Učitavanje...",
    "admin.role.admin": "Admin",
    "admin.role.super": "Super user",
    "admin.role.user": "Korisnik",
    "admin.you": "vi",
    "admin.changePw": "Lozinka",
    "admin.deleteTitle": "Obrisati nalog \"{u}\"?",
    "admin.deleteSub":
      "Svi njegovi unosi biće obrisani. Ova akcija se ne može poništiti.",
    "admin.cancel": "Odustani",
    "admin.delete": "Obriši",
    "admin.newAccountDesc": "Unesite korisničko ime, lozinku i ulogu.",
    "admin.role": "Uloga",
    "admin.assignSuper": "Dodijeli super useru (opciono)",
    "admin.assignNone": "Bez super usera",
    "admin.create": "Kreiraj",
    "admin.pwFor": "Nova lozinka za \"{u}\"",
    "admin.pwDesc": "Unesite novu lozinku (min. 4 znaka).",
    "admin.pwNew": "Nova lozinka",
    "admin.save": "Sačuvaj",
    "admin.pwTooShort": "Popunite korisničko ime i lozinku (min. 4 znaka)",
    "admin.created": "Nalog kreiran",
    "admin.pwChanged": "Lozinka promijenjena",
    "admin.deleted": "Nalog obrisan",

    "edit.title": "Izmijeni putovanje",
    "edit.subtitle": "Promijenite datum ulaska ili izlaska i sačuvajte.",
    "edit.cancel": "Odustani",
    "edit.save": "Sačuvaj",
    "edit.saving": "Čuvam...",
    "edit.saved": "Putovanje sačuvano",
    "edit.openTrip": "Otvoren boravak",

    "viewOther.banner":
      "Trenutno prikazujete podatke korisnika {u}. Svi novi unosi biće dodati njegovom nalogu.",

    "footer.developedBy": "Razvijeno od strane",
    "footer.imprint": "Impresum",
    "footer.privacy": "Politika privatnosti",
    "footer.cookiePrefs": "Podešavanja kolačića",

    "consent.banner.aria": "Obavijest o kolačićima",
    "consent.banner.title": "Poštujemo vašu privatnost",
    "consent.banner.body": "Koristimo neophodne kolačiće za rad aplikacije. Uz vaš pristanak, možemo učitati eksterne fontove (Google Fonts) i anonimnu statistiku posjeta (Google Analytics). Detalje pogledajte u politici privatnosti.",
    "consent.link.privacy": "Politika privatnosti",
    "consent.link.imprint": "Impresum",
    "consent.acceptAll": "Prihvati sve",
    "consent.rejectAll": "Odbaci sve",
    "consent.customize": "Prilagodi",
    "consent.save": "Sačuvaj izbor",
    "consent.dialog.title": "Podešavanja privatnosti",
    "consent.dialog.description": "Odaberite koje kategorije želite dozvoliti. Svoj izbor možete kasnije promijeniti u podnožju stranice.",
    "consent.cat.necessary.title": "Neophodno",
    "consent.cat.necessary.desc": "Prijava, jezik interfejsa i lokalno čuvanje boravaka. Bez ovih kolačića aplikacija ne radi.",
    "consent.cat.functional.title": "Funkcionalnost",
    "consent.cat.functional.desc": "Google Fonts (Outfit, Playfair Display, JetBrains Mono) za bolji izgled. IP se prenosi Google-u.",
    "consent.cat.statistics.title": "Statistika",
    "consent.cat.statistics.desc": "Google Analytics 4 sa anonimizovanim IP-om — mjerimo koje sekcije se koriste da unaprijedimo aplikaciju.",

    "legal.back": "Nazad na aplikaciju",

    "legal.imprint.title": "Impresum",
    "legal.imprint.responsible": "Odgovorno lice",
    "legal.imprint.contact": "Kontakt",
    "legal.imprint.legal": "Pravni podaci",
    "legal.imprint.responsiblePerson": "Odgovorno lice",
    "legal.imprint.register": "Trgovački registar",
    "legal.imprint.vat": "PDV ID",
    "legal.imprint.disclaimerTitle": "Odricanje odgovornosti",
    "legal.imprint.disclaimerBody": "Ova aplikacija služi kao informativni alat za tehnički obračun pravila 90/180 u šengenskom prostoru i ne predstavlja pravni savjet niti zvaničnu odluku nadležnih organa.",

    "legal.privacy.title": "Politika privatnosti",
    "legal.privacy.intro": "Ova politika opisuje koje lične podatke obrađujemo kada koristite Schengen 90/180 aplikaciju, u skladu sa Opštom uredbom o zaštiti podataka (GDPR / DSGVO).",
    "legal.privacy.controllerTitle": "Rukovalac podacima",
    "legal.privacy.dataTitle": "Koje podatke obrađujemo",
    "legal.privacy.dataBody": "Obrađujemo samo one podatke koje vi unesete ili koji su tehnički potrebni:",
    "legal.privacy.data.account": "Podaci naloga: korisničko ime, ime i prezime (opciono), heširana lozinka, uloga, firma kojoj pripadate.",
    "legal.privacy.data.trips": "Vaši uneseni boravci: datumi ulaska i izlaska iz šengenskog prostora.",
    "legal.privacy.data.company": "Podaci firme (ako ste član firme): naziv, adresa, telefon, web, logotip.",
    "legal.privacy.data.tech": "Tehnički podaci: JWT token u lokalnom skladištu vašeg pretraživača, jezik interfejsa.",
    "legal.privacy.purposeTitle": "Svrha obrade",
    "legal.privacy.purposeBody": "Podaci se obrađuju isključivo radi obračuna pravila 90/180 i vaše evidencije boravaka. Ne koristimo ih ni za kakav marketing niti profilisanje.",
    "legal.privacy.legalBasisTitle": "Pravni osnov",
    "legal.privacy.legalBasisBody": "Obrada se zasniva na Vašem ugovoru sa nama (čl. 6 st. 1 tač. b GDPR) i našem legitimnom interesu za pružanje bezbjedne usluge (čl. 6 st. 1 tač. f GDPR). Za statistiku (Google Analytics) i eksterne fontove (Google Fonts) tražimo Vaš izričit pristanak (čl. 6 st. 1 tač. a GDPR).",
    "legal.privacy.recipientsTitle": "Primaoci podataka",
    "legal.privacy.recipientsBody": "Podaci se čuvaju na našim serverima i ne dijele se sa trećim licima. Uz Vaš pristanak, Google (Ireland) Limited i Google LLC mogu obrađivati Vaš IP kada učitavate Google Fonts ili Google Analytics.",
    "legal.privacy.retentionTitle": "Rok čuvanja",
    "legal.privacy.retentionBody": "Podaci naloga i boravci čuvaju se dok postoji Vaš nalog. Nakon brisanja naloga, brišu se i svi Vaši podaci.",
    "legal.privacy.cookiesTitle": "Kolačići i lokalno skladište",
    "legal.privacy.cookiesBody": "Aplikacija koristi tri kategorije podataka u pretraživaču:",
    "legal.privacy.storage.necessary": "auth_token (prijava), lang (jezik), schengen-trips-v1 (privremeni podaci prije prijave). Rok: do odjave / brisanja podataka pretraživača.",
    "legal.privacy.storage.functional": "Google Fonts sa fonts.googleapis.com i fonts.gstatic.com. Ne postavlja kolačiće, ali prenosi Vaš IP Google-u.",
    "legal.privacy.storage.statistics": "Google Analytics 4 (ID: {id}) sa anonimizovanim IP-om. Kolačići _ga, _ga_*. Rok: do 2 godine.",
    "legal.privacy.changePrefs": "Promijeni podešavanja kolačića",
    "legal.privacy.rightsTitle": "Vaša prava",
    "legal.privacy.rightsBody": "Prema GDPR-u imate sljedeća prava:",
    "legal.privacy.rights.access": "Pravo pristupa (čl. 15) — možete zatražiti kopiju svojih podataka.",
    "legal.privacy.rights.rectify": "Pravo ispravke (čl. 16) — netačne podatke ispravljate direktno u aplikaciji ili nas kontaktirajte.",
    "legal.privacy.rights.erase": "Pravo brisanja (čl. 17) — nalog i podaci se brišu na Vaš zahtjev.",
    "legal.privacy.rights.restrict": "Pravo ograničenja obrade (čl. 18).",
    "legal.privacy.rights.portability": "Pravo prenosivosti (čl. 20) — možete izvesti svoje boravke u PDF/CSV.",
    "legal.privacy.rights.object": "Pravo prigovora (čl. 21) na obradu zasnovanu na legitimnom interesu.",
    "legal.privacy.rights.complain": "Pravo pritužbe nadzornom organu (npr. BayLDA u Njemačkoj).",
    "legal.privacy.rightsContact": "Za ostvarivanje prava, pišite nam na",
    "legal.privacy.securityTitle": "Bezbjednost",
    "legal.privacy.securityBody": "Koristimo HTTPS, bcrypt heširanje lozinki, JWT tokene, kontrolu pristupa po ulogama i zaštitu datoteka. Redovno provjeravamo sistem.",
    "legal.privacy.updatesTitle": "Izmjene politike",
    "legal.privacy.updatesBody": "Ovu politiku možemo ažurirati radi usklađenosti sa zakonom ili novim funkcionalnostima. Materijalne izmjene ćemo istaknuti u aplikaciji.",

    "sidebar.company": "Firma",
    "sidebar.filterCompany": "Filter po firmi",
    "sidebar.allCompanies": "Sve firme",
    "sidebar.noCompany": "Bez firme",
    "sidebar.users": "Korisnici",
  },
  de: {
    "brand.tagline": "Aufenthaltsrechner",
    "brand.title": "Schengen 90 / 180",
    "brand.rule": "max. 90 Tage · gleitender 180-Tage-Zeitraum",
    "brand.forCompany": "für",

    "login.title": "Anmeldung",
    "login.subtitle": "Firmennamen, Benutzernamen und Passwort eingeben.",
    "login.company": "Firma",
    "login.companyPlaceholder": "Benutzername der Firma (z. B. expresstrans)",
    "login.username": "Benutzername",
    "login.password": "Passwort",
    "login.submit": "Anmelden",
    "login.submitting": "Anmeldung...",
    "login.noSelfSignup": "Konten werden vom Administrator erstellt.",
    "login.developedBy": "Entwickelt von",
    "login.errorEmpty": "Bitte Benutzername und Passwort eingeben",
    "login.errorFailed": "Anmeldung fehlgeschlagen",
    "login.success": "Erfolgreich angemeldet",

    "header.loggedInAs": "Angemeldet als",
    "header.admin": "Admin",
    "header.logout": "Abmelden",

    "tabs.today": "Prüfung für heute",
    "tabs.plan": "Reiseplanung",

    "chip.yearForQuickEntry": "Jahr für Schnelleingabe",
    "chip.viewing": "Angezeigt",

    "status.ok": "Erlaubt",
    "status.warning": "Riskant - nahe am Limit",
    "status.overage": "Überschreitung",
    "status.label": "Status:",
    "status.lastExit": "Letzter zulässiger Ausreisetag:",

    "metric.used": "Genutzte Tage",
    "metric.remaining": "Verbleibende Tage",
    "metric.mustExitBy": "Ausreise spätestens am:",
    "metric.mustExitBy.explainTitle": "Wie wird dieses Datum berechnet?",
    "metric.mustExitBy.explain": "Der Algorithmus simuliert für jeden Tag zwischen heute und +180 Tagen die Ausreise und berechnet die Aufenthaltstage im gleitenden Fenster [D − 179, D]. {date} ist der späteste Tag, an dem diese Summe ≤ 90 ist.",
    "metric.mustExitBy.note": "Wenn sich das Fenster nach vorn verschiebt, „fallen\" ältere Aufenthalte allmählich heraus und geben Platz für neue Tage frei.",
    "metric.overage": "Überschreitung",
    "metric.window": "Aktiver Zeitraum",
    "metric.windowSub": "180 Kalendertage",
    "metric.overageStart": "Überschreitung ab",
    "metric.reentry": "Wiedereinreise ab",

    "timeline.title": "Zeitachse · 180 Tage",
    "timeline.usageOf90": "Auslastung des 90-Tage-Limits",
    "timeline.legend.stay": "Aufenthaltstage",
    "timeline.legend.active": "Aktiver (offener) Aufenthalt",
    "timeline.legend.overage": "Überschreitung",
    "timeline.legend.free": "Freie Tage",
    "timeline.days": "Tage",
    "timeline.open": "offen",
    "timeline.tooltip.noStay": "Kein Aufenthalt in diesem Abschnitt",
    "timeline.tooltip.overageHere": "Überschreitung an diesen Tagen",

    "calendar.title": "Kalenderansicht",
    "calendar.today": "Heute",
    "calendar.legend.stay": "Aufenthaltstag",
    "calendar.legend.overage": "Überschreitung",
    "calendar.legend.window": "Aktiver 180-Tage-Zeitraum",

    "add.title": "Reise hinzufügen",
    "add.subtitle": "Einreise & Ausreise",
    "add.entry": "Einreise",
    "add.exit": "Ausreise",
    "add.openTrip": "Offener Aufenthalt (Ausreise noch nicht erfolgt)",
    "add.button": "Reise hinzufügen",
    "add.needEntry": "Einreisedatum eingeben",
    "add.needExit": "Ausreisedatum eingeben oder offenen Aufenthalt markieren",
    "add.exitBeforeEntry": "Die Ausreise darf nicht vor der Einreise liegen",
    "add.saved": "Reise hinzugefügt",

    "trips.title": "Reiseverlauf",
    "trips.count.one": "Eintrag",
    "trips.count.many": "Einträge",
    "trips.loading": "Wird geladen...",
    "trips.empty.title": "Noch keine Reisen erfasst",
    "trips.empty.sub": "Fügen Sie die erste Reise hinzu oder laden Sie das Beispiel.",
    "trips.totalPrefix": "Gesamt:",
    "trips.days.one": "Tag",
    "trips.days.many": "Tage",
    "trips.inWindow": "Im aktuellen Zeitraum:",
    "trips.overlap": "Überlappung",
    "trips.ongoing": "laufend",
    "trips.open": "offen",
    "trips.showMore": "Weitere {n} anzeigen",
    "trips.showLess": "Weniger anzeigen",
    "trips.legend.inWindow": "Fällt in das aktuelle 180-Tage-Fenster (zählt)",
    "trips.legend.outOfWindow": "Außerhalb des Fensters (zählt nicht mehr)",
    "trips.closeTrip": "Aufenthalt schließen (heute)",
    "trips.closedOk": "Aufenthalt geschlossen am {d}",

    "plan.checkTitle": "Prüfung für zukünftiges Datum",
    "plan.checkSubtitle": "Wählen Sie ein zukünftiges Datum als Prüfdatum.",
    "plan.checkDate": "Prüfdatum",
    "plan.stat.used": "Genutzt",
    "plan.stat.remaining": "Verbleibend",
    "plan.stat.overage": "Überschreitung",
    "plan.title": "Reiseplanung",
    "plan.subtitle":
      "Simulieren Sie geplante Einreise und Ausreise, um zu prüfen, ob die Reise zulässig ist.",
    "plan.plannedEntry": "Geplante Einreise",
    "plan.plannedExit": "Geplante Ausreise",
    "plan.maxStayPrefix": "Maximal zusammenhängender Aufenthalt ab",
    "plan.result.ok": "Reise ist möglich",
    "plan.result.okSub":
      "Nach dem geplanten Aufenthalt: {used}/90 Tage, verbleibend {remaining}.",
    "plan.result.exitBeforeEntry": "Ausreise liegt vor der Einreise",
    "plan.result.exitBeforeEntrySub": "Bitte überprüfen Sie die eingegebenen Daten.",
    "plan.result.overage": "Überschreitung um {days} {dayWord}",
    "plan.result.overageSub":
      "Der geplante Aufenthalt dauert {plannedDays} Tage - zu viel im Vergleich zum aktuell Verfügbaren.",

    "actions.loadSample": "Beispiel laden",
    "actions.exportPdf": "PDF-Export",
    "actions.importCsv": "CSV importieren",
    "actions.downloadCsvSample": "CSV-Beispiel laden",
    "actions.reset": "Alles zurücksetzen",
    "actions.resetConfirmTitle": "Alle Einträge löschen?",
    "actions.resetConfirmSub":
      "Diese Aktion löscht den gesamten Reiseverlauf und kann nicht rückgängig gemacht werden.",
    "actions.cancel": "Abbrechen",
    "actions.confirmDelete": "Alles löschen",
    "actions.pdfOk": "PDF-Bericht erstellt",
    "actions.pdfErr": "Fehler beim Erstellen des PDF",
    "actions.csvOk": "{n} Reisen aus CSV geladen",
    "actions.csvSkipped": " ({n} ungültige Zeilen übersprungen)",
    "actions.csvErr": "Import fehlgeschlagen: {msg}",
    "actions.csvSample": "CSV-Beispiel heruntergeladen",
    "actions.resetDone": "Alle Einträge wurden gelöscht",

    "explanation.title": "Wie funktioniert die 90/180-Regel?",
    "explanation.p1":
      "Bürger von Bosnien und Herzegowina, Serbien und Montenegro dürfen sich ohne Visum höchstens {b1}90 Tage{b2} innerhalb eines beliebigen gleitenden Zeitraums von {b1}180 Tagen{b2} im Schengen-Raum aufhalten.",
    "explanation.li1":
      "Für jedes Prüfdatum werden genau 180 Kalendertage rückwärts betrachtet.",
    "explanation.li2":
      "Sowohl der {b1}Einreisetag{b2} als auch der {b1}Ausreisetag{b2} zählen als volle Aufenthaltstage.",
    "explanation.li3":
      "Aufenthalte in verschiedenen Schengen-Ländern werden als ein einziger Aufenthalt summiert.",
    "explanation.li4":
      "Neue Tage werden schrittweise „freigegeben\" - an dem Tag, an dem der alte Tag aus dem 180-Tage-Fenster fällt.",
    "explanation.li5":
      "Bei überlappenden Einträgen werden diese zusammengeführt, damit Tage nicht doppelt gezählt werden.",
    "explanation.note":
      "Hinweis: Dies ist eine technische Berechnung. Die zuständigen Grenzbehörden behalten sich das Recht der endgültigen Entscheidung vor.",

    "disclaimer.title": "Hinweis",
    "disclaimer.text":
      "Diese Anwendung dient als informatives Werkzeug zur technischen Berechnung der 90/180-Regel im Schengen-Raum und stellt keine Rechtsberatung oder amtliche Entscheidung dar.",

    "admin.title": "Verwaltung",
    "admin.back": "Zurück",
    "admin.newAccount": "Neues Konto",
    "admin.users": "Benutzer",
    "admin.accounts.one": "Konto",
    "admin.accounts.many": "Konten",
    "admin.loading": "Wird geladen...",
    "admin.role.admin": "Admin",
    "admin.role.super": "Super-User",
    "admin.role.user": "Benutzer",
    "admin.you": "Sie",
    "admin.changePw": "Passwort",
    "admin.deleteTitle": "Konto \"{u}\" löschen?",
    "admin.deleteSub":
      "Alle Einträge werden gelöscht. Diese Aktion ist unumkehrbar.",
    "admin.cancel": "Abbrechen",
    "admin.delete": "Löschen",
    "admin.newAccountDesc": "Benutzername, Passwort und Rolle eingeben.",
    "admin.role": "Rolle",
    "admin.assignSuper": "Super-User zuweisen (optional)",
    "admin.assignNone": "Ohne Super-User",
    "admin.create": "Erstellen",
    "admin.pwFor": "Neues Passwort für \"{u}\"",
    "admin.pwDesc": "Neues Passwort eingeben (min. 4 Zeichen).",
    "admin.pwNew": "Neues Passwort",
    "admin.save": "Speichern",
    "admin.pwTooShort": "Benutzername und Passwort ausfüllen (min. 4 Zeichen)",
    "admin.created": "Konto erstellt",
    "admin.pwChanged": "Passwort geändert",
    "admin.deleted": "Konto gelöscht",

    "edit.title": "Reise bearbeiten",
    "edit.subtitle": "Ein- oder Ausreisedatum ändern und speichern.",
    "edit.cancel": "Abbrechen",
    "edit.save": "Speichern",
    "edit.saving": "Speichere...",
    "edit.saved": "Reise gespeichert",
    "edit.openTrip": "Offener Aufenthalt",

    "viewOther.banner":
      "Sie sehen aktuell die Daten von {u}. Neue Einträge werden diesem Konto hinzugefügt.",

    "footer.developedBy": "Entwickelt von",
    "footer.imprint": "Impressum",
    "footer.privacy": "Datenschutz",
    "footer.cookiePrefs": "Cookie-Einstellungen",

    "consent.banner.aria": "Cookie-Hinweis",
    "consent.banner.title": "Wir respektieren Ihre Privatsphäre",
    "consent.banner.body": "Wir verwenden notwendige Cookies für den Betrieb der Anwendung. Mit Ihrer Einwilligung laden wir externe Schriften (Google Fonts) und anonyme Nutzungsstatistiken (Google Analytics). Details in der Datenschutzerklärung.",
    "consent.link.privacy": "Datenschutzerklärung",
    "consent.link.imprint": "Impressum",
    "consent.acceptAll": "Alle akzeptieren",
    "consent.rejectAll": "Alle ablehnen",
    "consent.customize": "Anpassen",
    "consent.save": "Auswahl speichern",
    "consent.dialog.title": "Datenschutz-Einstellungen",
    "consent.dialog.description": "Wählen Sie, welche Kategorien Sie zulassen möchten. Sie können Ihre Wahl jederzeit im Footer ändern.",
    "consent.cat.necessary.title": "Notwendig",
    "consent.cat.necessary.desc": "Anmeldung, Sprache und lokale Speicherung. Ohne diese funktioniert die Anwendung nicht.",
    "consent.cat.functional.title": "Funktional",
    "consent.cat.functional.desc": "Google Fonts (Outfit, Playfair Display, JetBrains Mono) für ein schöneres Erscheinungsbild. IP wird an Google übertragen.",
    "consent.cat.statistics.title": "Statistik",
    "consent.cat.statistics.desc": "Google Analytics 4 mit anonymisierter IP — wir messen, welche Bereiche genutzt werden, um die Anwendung zu verbessern.",

    "legal.back": "Zurück zur Anwendung",

    "legal.imprint.title": "Impressum",
    "legal.imprint.responsible": "Verantwortlich",
    "legal.imprint.contact": "Kontakt",
    "legal.imprint.legal": "Rechtliche Angaben",
    "legal.imprint.responsiblePerson": "Verantwortliche Person",
    "legal.imprint.register": "Handelsregister",
    "legal.imprint.vat": "USt-IdNr.",
    "legal.imprint.disclaimerTitle": "Haftungsausschluss",
    "legal.imprint.disclaimerBody": "Diese Anwendung dient ausschließlich als informatives Werkzeug zur technischen Berechnung der 90/180-Regel im Schengen-Raum und stellt keine Rechtsberatung oder amtliche Entscheidung dar.",

    "legal.privacy.title": "Datenschutzerklärung",
    "legal.privacy.intro": "Diese Erklärung beschreibt, welche personenbezogenen Daten wir verarbeiten, wenn Sie die Schengen 90/180-Anwendung nutzen, in Übereinstimmung mit der Datenschutz-Grundverordnung (DSGVO).",
    "legal.privacy.controllerTitle": "Verantwortlicher",
    "legal.privacy.dataTitle": "Welche Daten wir verarbeiten",
    "legal.privacy.dataBody": "Wir verarbeiten ausschließlich die Daten, die Sie eingeben oder die technisch notwendig sind:",
    "legal.privacy.data.account": "Kontodaten: Benutzername, Vor- und Nachname (optional), gehashtes Passwort, Rolle, zugeordnete Firma.",
    "legal.privacy.data.trips": "Ihre Aufenthalte: Ein- und Ausreisedaten im Schengen-Raum.",
    "legal.privacy.data.company": "Firmendaten (falls Sie einer Firma zugeordnet sind): Name, Adresse, Telefon, Web, Logo.",
    "legal.privacy.data.tech": "Technische Daten: JWT-Token im lokalen Speicher Ihres Browsers, Sprache der Oberfläche.",
    "legal.privacy.purposeTitle": "Zweck der Verarbeitung",
    "legal.privacy.purposeBody": "Die Daten werden ausschließlich zur Berechnung der 90/180-Regel und zur Verwaltung Ihrer Aufenthalte verarbeitet. Kein Marketing und kein Profiling.",
    "legal.privacy.legalBasisTitle": "Rechtsgrundlage",
    "legal.privacy.legalBasisBody": "Die Verarbeitung erfolgt auf Grundlage des Vertrags mit Ihnen (Art. 6 Abs. 1 lit. b DSGVO) sowie unseres berechtigten Interesses am sicheren Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Für Statistik (Google Analytics) und externe Schriften (Google Fonts) holen wir Ihre ausdrückliche Einwilligung ein (Art. 6 Abs. 1 lit. a DSGVO).",
    "legal.privacy.recipientsTitle": "Empfänger",
    "legal.privacy.recipientsBody": "Die Daten werden auf unseren Servern gespeichert und nicht an Dritte weitergegeben. Mit Ihrer Einwilligung können Google Ireland Limited und Google LLC Ihre IP-Adresse verarbeiten, wenn Google Fonts oder Google Analytics geladen werden.",
    "legal.privacy.retentionTitle": "Speicherdauer",
    "legal.privacy.retentionBody": "Kontodaten und Aufenthalte werden gespeichert, solange Ihr Konto besteht. Bei Kontolöschung werden auch alle zugehörigen Daten gelöscht.",
    "legal.privacy.cookiesTitle": "Cookies und lokaler Speicher",
    "legal.privacy.cookiesBody": "Die Anwendung verwendet drei Kategorien von Browser-Speicher:",
    "legal.privacy.storage.necessary": "auth_token (Anmeldung), lang (Sprache), schengen-trips-v1 (temporäre Daten vor Anmeldung). Dauer: bis zur Abmeldung / Browser-Löschung.",
    "legal.privacy.storage.functional": "Google Fonts von fonts.googleapis.com und fonts.gstatic.com. Setzt keine Cookies, überträgt jedoch Ihre IP an Google.",
    "legal.privacy.storage.statistics": "Google Analytics 4 (ID: {id}) mit anonymisierter IP. Cookies _ga, _ga_*. Dauer: bis zu 2 Jahre.",
    "legal.privacy.changePrefs": "Cookie-Einstellungen ändern",
    "legal.privacy.rightsTitle": "Ihre Rechte",
    "legal.privacy.rightsBody": "Nach DSGVO stehen Ihnen folgende Rechte zu:",
    "legal.privacy.rights.access": "Auskunftsrecht (Art. 15) — Sie können eine Kopie Ihrer Daten anfordern.",
    "legal.privacy.rights.rectify": "Recht auf Berichtigung (Art. 16) — unrichtige Daten korrigieren Sie direkt in der App oder kontaktieren uns.",
    "legal.privacy.rights.erase": "Recht auf Löschung (Art. 17) — Konto und Daten werden auf Anfrage gelöscht.",
    "legal.privacy.rights.restrict": "Recht auf Einschränkung der Verarbeitung (Art. 18).",
    "legal.privacy.rights.portability": "Recht auf Datenübertragbarkeit (Art. 20) — Sie können Ihre Aufenthalte als PDF/CSV exportieren.",
    "legal.privacy.rights.object": "Widerspruchsrecht (Art. 21) gegen berechtigte-Interessen-Verarbeitung.",
    "legal.privacy.rights.complain": "Beschwerderecht bei einer Aufsichtsbehörde (z. B. BayLDA in Bayern).",
    "legal.privacy.rightsContact": "Zur Ausübung Ihrer Rechte schreiben Sie uns an",
    "legal.privacy.securityTitle": "Sicherheit",
    "legal.privacy.securityBody": "Wir verwenden HTTPS, bcrypt-Passwort-Hashing, JWT-Tokens, rollenbasierte Zugriffskontrolle und Datei-Schutz. Das System wird regelmäßig geprüft.",
    "legal.privacy.updatesTitle": "Änderungen dieser Erklärung",
    "legal.privacy.updatesBody": "Wir können diese Erklärung an neue rechtliche Anforderungen oder Funktionen anpassen. Wesentliche Änderungen weisen wir in der App hervor.",

    "sidebar.company": "Firma",
    "sidebar.filterCompany": "Nach Firma filtern",
    "sidebar.allCompanies": "Alle Firmen",
    "sidebar.noCompany": "Keine Firma",
    "sidebar.users": "Benutzer",
  },
};

const format = (str, params) => {
  if (!params) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (params[k] != null ? String(params[k]) : ""));
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "sr");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, params) => {
      const val = dict[lang]?.[key] ?? dict.sr[key] ?? key;
      return format(val, params);
    },
    [lang],
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export const useT = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useT must be used inside I18nProvider");
  return ctx;
};

export const availableLangs = ["sr", "de"];
